import React, { useEffect, useState } from "react";
import "./Cart.css";
import Card from "../../components/ProductCard/Card";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import base_url from "../../api";

const Cart = () => {
  const [cartItems, setCartItems] = useState([]);
  const [product, setProduct] = useState([]);

  // Fetch product list from backend
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch(`${base_url}/products`);
        const data = await res.json();
        setProduct(data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchProducts();
  }, []);

  // Sync cart from localStorage
  useEffect(() => {
    const storedItems = JSON.parse(localStorage.getItem("itemsId")) || [];
    if (product.length > 0 && storedItems.length > 0) {
      const matchedItems = storedItems
        .map((cartObj, index) => {
          const p = product.find((prod) => prod.id === cartObj.id);
          if (!p) return null;

          // ✅ If images is a JSON string, parse it
          let imagesObj = p.images;
          if (typeof imagesObj === "string") {
            try {
              imagesObj = JSON.parse(imagesObj);
            } catch (e) {
              console.error("Invalid images JSON:", p.images);
              return null;
            }
          }

          const color =
            cartObj.color && cartObj.color !== "null"
              ? cartObj.color
              : Object.keys(imagesObj)[0];

          const firstImage =
            color && Array.isArray(imagesObj[color]) && imagesObj[color].length > 0
              ? imagesObj[color][0]
              : imagesObj[Object.keys(imagesObj)[0]]?.[0] || "default.jpg";

          const imgSrc = firstImage.includes("http")
            ? firstImage
            : `${base_url}/images/${firstImage}`;

          return {
            key: `${p.id}-${color}-${cartObj.size}-${index}`,
            id: p.id,
            name: p.name,
            price: parseFloat(p.price),
            qty: cartObj.quantity,
            color,
            size: cartObj.size,
            img: imgSrc,
          };
        })
        .filter(Boolean);

      console.log("Matched Items:", matchedItems);
      setCartItems(matchedItems);
    }
  }, [product]);


  // Countries/States/Cities
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [houseNo, setHouseNo] = useState("");
  const [street, setStreet] = useState("");
  const [landmark, setLandmark] = useState("");
  const [contact, setContact] = useState("");

  useEffect(() => {
    fetch("https://countriesnow.space/api/v0.1/countries/states")
      .then((res) => res.json())
      .then((data) => {
        if (data.data && Array.isArray(data.data)) setCountries(data.data);
      })
      .catch((err) => console.error(err));
  }, []);

  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
    setCountry(selectedCountry);
    const countryData = countries.find((c) => c.name === selectedCountry);
    setStates(countryData ? countryData.states : []);
    setState("");
    setCities([]);
  };

  const handleStateChange = async (e) => {
    const selectedState = e.target.value;
    setState(selectedState);
    setCities([]);
    if (!country || !selectedState) return;

    try {
      const res = await fetch(
        "https://countriesnow.space/api/v0.1/countries/state/cities",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ country, state: selectedState }),
        }
      );
      const data = await res.json();
      setCities(Array.isArray(data.data) ? data.data : []);
    } catch (err) {
      console.error(err);
    }
  };

  const discount = 0;
  const shipping = 0;
  const subtotal = cartItems.reduce((acc, item) => acc + item.price * item.qty, 0);
  const total = subtotal - discount + shipping;

  // Update quantity
  const updateQty = (item, delta) => {
    setCartItems((prev) => {
      const updated = prev.map((i) =>
        i.id === item.id && i.color === item.color && i.size === item.size
          ? { ...i, qty: Math.max(1, i.qty + delta) }
          : i
      );

      const storedItems = JSON.parse(localStorage.getItem("itemsId")) || [];
      const newStored = storedItems.map((i) =>
        i.id === item.id && i.color === item.color && i.size === item.size
          ? { ...i, quantity: Math.max(1, i.quantity + delta) }
          : i
      );
      localStorage.setItem("itemsId", JSON.stringify(newStored));

      return updated;
    });
  };
  const increaseQty = (item) => updateQty(item, 1);
  const decreaseQty = (item) => updateQty(item, -1);

  // Remove item
  const removeItem = (item) => {
    const updated = cartItems.filter(
      (i) => !(i.id === item.id && i.color === item.color && i.size === item.size)
    );
    setCartItems(updated);

    const storedItems = JSON.parse(localStorage.getItem("itemsId")) || [];
    const newStored = storedItems.filter(
      (i) => !(i.id === item.id && i.color === item.color && i.size === item.size)
    );
    localStorage.setItem("itemsId", JSON.stringify(newStored));
  };

  // Place order
  const placeOrder = () => {
    if (!country || !state || !city || !houseNo || !contact) {
      alert("Please fill all required fields!");
      return;
    }

    // All amounts are saved in CAD regardless of country
    const order = {
      items: cartItems,
      address: { country, state, city, houseNo, street, landmark, contact },
      total: total, // Amount in CAD
      currency: "CAD" // Explicitly set currency to CAD
    };

    fetch(`${base_url}/orders`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(order),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          toast.error(data.error, { position: "top-right", autoClose: 5000 });
          return;
        }
        toast.success("Order Placed Successfully!", { position: "top-right", autoClose: 2000 });
        setTimeout(() => (window.location.href = "/"), 2000);
        localStorage.removeItem("itemsId");
        setCartItems([]);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Failed to place order. Please try again.", { position: "top-right", autoClose: 5000 });
      });
  };

  return (
    <div className="cart-main">
      <div className="cart-container">
        <div className="cart-items">
          <h2>Products</h2>
          {cartItems.length === 0 ? (
            <p>Your cart is empty</p>
          ) : (
            cartItems.map((item) => (
              <div className="cart-row" key={item.key}>
                <div className="image-details">
                <img src={item.img} alt={item.name} />

                <div className="item-details">
                  <h4>{item.name}</h4>
                  <div className="options">
                    <span>Color: {item.color || "Default"}</span> &nbsp;
                    <span>Size: {item.size || "Default"}</span>
                  </div>
                </div>
                </div>
                <div className="cart-quantity-details">
                  <p>${item.price}</p>
                  <div className="quantity">
                    <button onClick={() => decreaseQty(item)}>-</button>
                    <span>{item.qty}</span>
                    <button onClick={() => increaseQty(item)}>+</button>
                  </div>
                  <p>${(item.price * item.qty).toFixed(2)}</p>
                  <button className="remove-btn" onClick={() => removeItem(item)}>
                    ×
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Order Summary */}
        <div className="order-summary">
          <h2>Order Summary</h2>
          <div className="summary-row">
            <span>Subtotal</span>
            <span>${subtotal.toFixed(2)}</span>
          </div>
          <div className="summary-row">
            <span>Discounts</span>
            <span>-${discount}</span>
          </div>
          <div className="summary-row shipping">
            <span>Shipping</span>
            <span>${shipping}</span>
          </div>
          <div className="summary-row total">
            <span>Total</span>
            <span>${total.toFixed(2)}</span>
          </div>
          <div className="terms">
            <input type="checkbox" /> I agree with the <a href="/">Terms And Conditions</a>
          </div>
          <a href="MeasurementForm"><button className="checkout-btn">Add mesurements</button></a>
          <p className="continue">Or</p>
          <button className="checkout-btn">Invite Friends</button>
        </div>
      </div>

      {/* Address Section */}
      <div className="address-section">
        <h2>Shipping Address</h2>
        <div className="address-form">
          <div>
            <select value={country} onChange={handleCountryChange}>
              <option value="">Select Country</option>
              {countries.length > 0 ? countries.map((c, i) => (
                <option key={i} value={c.name}>{c.name}</option>
              )) : <option>Loading...</option>}
            </select>

            <select value={state} onChange={handleStateChange} disabled={!states.length}>
              <option value="">Select State</option>
              {states.map((s, i) => (
                <option key={i} value={s.name}>{s.name}</option>
              ))}
            </select>

            <select value={city} onChange={(e) => setCity(e.target.value)} disabled={!cities.length}>
              <option value="">Select City</option>
              {cities.map((c, i) => (
                <option key={i} value={c}>{c}</option>
              ))}
            </select>
          </div>

          <div>
            <input type="text" placeholder="House Number" value={houseNo} onChange={(e) => setHouseNo(e.target.value)} />
            <input type="text" placeholder="Street Address" value={street} onChange={(e) => setStreet(e.target.value)} />
            <input type="text" placeholder="Landmark" value={landmark} onChange={(e) => setLandmark(e.target.value)} />
            <input type="text" placeholder="Contact Number" value={contact} onChange={(e) => setContact(e.target.value)} />
          </div>
        </div>

        <button className="place-order-btn" onClick={placeOrder}>Place Order</button>
      </div>

      {/* You may also like */}
      <div className="like-section">You may also like</div>
      <div className="product-list">
        {product.slice(0, 4).map((p, i) => (
          <Card key={i} id={p.id} image={p.images} name={p.name} description={p.description} price={p.price} />
        ))}
      </div>

      <ToastContainer />
    </div>
  );
};

export default Cart;
